<template>
  <div>
    <!-- desktop view -->
    <div
      v-if="screen.isDesktop"
      ref="overseas-phone"
      class="overseas-phone-card--uniform"
      :class="{ active: isShowOverseas }"
      :style="searchResultStyle"
    >
      <div class="field-new">
        <div class="fieldarea">
          <div class="fieldarea fieldarea--addon-new">
            <span id="search-icon" class="fieldarea__addon-new">
              <i class="icon icon_search"></i>
            </span>
            <input
              id="search"
              v-model="search"
              type="text"
              class="text"
              placeholder="Search country name or code"
              name="search"
              @focus="addClass"
              @blur="removeClass"
            />
          </div>
        </div>
      </div>
      <div class="list-overseas">
        <div v-if="filteredCountry.length" class="scrollable">
          <template v-for="(item, index) in filteredCountry">
            <a :key="index" class="list-overseas__item" @click.prevent="saveCountry(item)">
              <img :src="item.flag" class="field__icon-flag" />
              <span class="code">{{ `${item.phone_code}` }}</span>
              <span class="nation">{{ item.name }}</span>
            </a>
          </template>
        </div>
        <div v-else class="centered">
          <img src="/assets/img/country-not-found.svg" class="not-found" />
          <p>
            Sorry, the country you are looking for <br />
            could not be found.
          </p>
        </div>
      </div>
    </div>

    <!-- mobile view -->
    <GModal v-if="!screen.isDesktop && isShowOverseas" id="pills-dropdown-mobile" class="pills-dropdown-mobile">
      <template slot="header">
        <div class="rectangle-top"></div>
        <div class="modal-heading">
          <h4 class="modal-heading--title">SELECT A COUNTRY</h4>
          <a
            href=""
            type="button"
            class="close modal-heading--close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="showOverseas()"
          >
            <img src="/assets/img/icons/close-modal.svg" height="14" width="14" />
          </a>
        </div>
      </template>
      <template slot="body">
        <div class="field-new">
          <div class="fieldarea">
            <div class="fieldarea fieldarea--addon-new">
              <span id="search-icon" class="fieldarea__addon-new">
                <i class="icon icon_search"></i>
              </span>
              <input
                id="search"
                v-model="search"
                type="text"
                class="text"
                placeholder="Search country name or code"
                name="search"
                @focus="addClass"
                @blur="removeClass"
              />
            </div>
          </div>
        </div>
        <div class="list-overseas">
          <div v-if="filteredCountry.length" class="scrollable">
            <template v-for="(item, index) in filteredCountry">
              <a :key="index" class="list-overseas__item" @click.prevent="saveCountry(item)">
                <img :src="item.flag" class="field__icon-flag" />
                <span class="code">{{ `${item.phone_code}` }}</span>
                <span class="nation">{{ item.name }}</span>
              </a>
            </template>
          </div>
          <div v-else class="centered">
            <img src="/assets/img/country-not-found.svg" class="not-found" />
            <p>
              Sorry, the country you are looking for <br />
              could not be found.
            </p>
          </div>
        </div>
      </template>
    </GModal>
  </div>
</template>
<script>
export default {
  name: 'OverseasPhone',
  data() {
    return {
      search: '',
      searchResultStyle: {},
    };
  },
  computed: {
    screen() {
      return this.$store.state.screen;
    },
    isShowOverseas() {
      return this.$store.state.modal.isModalShow.overseasPhone;
    },
    filteredCountry() {
      return this.$store.state.otp.country.filter((item) => {
        // return item.name.toLowerCase().includes(this.search.toLowerCase());
        return (
          item.name.toLowerCase().indexOf(this.search.toString().toLowerCase()) > -1 ||
          item.phone_code.toString().indexOf(this.search.toString().toLowerCase()) > -1
        );
      });
    },
  },
  watch: {
    isShowOverseas: {
      immediate: true,
      handler(newVal) {
        if (newVal === true && this.screen.isDesktop) {
          this.$SO('body').removeClass('no-scroll');
        }
      },
    },
  },
  mounted() {
    if (this.$store.state.screen.isDesktop) {
      this.$SO('body').removeClass('no-scroll');
    }
    // this.calculateHeight('overseas-phone');
  },
  beforeDestroy() {
    this.$SO('#app').removeClass('noscroll');
    document.documentElement.classList.remove('noscroll');
  },
  methods: {
    showOverseas() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'overseasPhone',
      });
    },
    saveCountry(item) {
      this.$store.commit('saveCountry', item);
      this.showOverseas();
    },
    addClass() {
      const target = document.querySelectorAll('.fieldarea__addon-new');
      for (const box of target) {
        box.classList.add('focusss');
      }
    },
    removeClass() {
      const target = document.querySelectorAll('.fieldarea__addon-new');
      for (const box of target) {
        box.classList.remove('focusss');
      }
    },
    // calculateHeight(ref) {
    //   const style = {
    //     top: this.top,
    //   };
    //   const search = this.$refs[ref];
    //   const innerHeight = window.innerHeight;
    //   if (search) {
    //     const searchRects = search.getClientRects();
    //     if (searchRects[0]?.top) {
    //       style['--viewport-height'] = `${innerHeight - searchRects[0].top}px`;
    //     }
    //   }
    //   this.searchResultStyle = style;
    // },
  },
};
</script>
<style lang="scss" scoped>
@import 'overseas-phone';
</style>
